import { Button, Flex } from '@chakra-ui/react';

export type LeaderboardMetric = 'count' | 'points';

interface LeaderboardTabsProps {
  value: LeaderboardMetric;
  onChange: (metric: LeaderboardMetric) => void;
}

const TABS: { key: LeaderboardMetric; label: string }[] = [
  { key: 'count', label: 'By count' },
  { key: 'points', label: 'By points' },
];

function LeaderboardTabs({ value, onChange }: LeaderboardTabsProps) {
  return (
    <Flex w="full">
      {TABS.map((tab, i) => {
        const active = value === tab.key;
        const bg = active ? 'white' : 'brand.lightGray1';
        return (
          <Button
            key={tab.key}
            onClick={() => onChange(tab.key)}
            flex="1"
            maxW="246px"
            h="40px"
            minW="0"
            borderRadius="8px"
            boxShadow="0 1px 3px rgba(0, 0, 0, 0.1)"
            bg={bg}
            color={active ? 'brand.purple' : 'brand.darkGray'}
            textStyle="smallSemiBold"
            zIndex={active ? 1 : 0}
            ml={i === 0 ? 0 : '-8px'}
            _hover={{ bg }}
            _active={{ bg }}
          >
            {tab.label}
          </Button>
        );
      })}
    </Flex>
  );
}

export default LeaderboardTabs;
